/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the AnalyticsApiConfiguration configuration object with a given root URL.
 */
export function provideAnalyticsApiConfiguration(rootUrl: string) {
  var config = new AnalyticsApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: AnalyticsApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AnalyticsApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `O2AnalyticsApiModule.forRoot()`
 */
export interface AnalyticsApiConfigurationParams {
  rootUrl?: string;
}
